import { SkinDefinition, SkinId } from "./types";

export const DEFAULT_SKIN_ID: SkinId = "legacy";

export const legacySkin: SkinDefinition = {
  id: "legacy",
  label: "Legacy",
  tokens: {
    "--skin-page-bg": "var(--color-bg-1)",
    "--skin-shell-backdrop-bg": "var(--color-bg-2)",
    "--skin-surface-bg": "var(--color-bg-2)",
    "--skin-overlay-bg": "var(--color-bg-2)",
    "--skin-text-primary": "var(--color-text-1)",
    "--skin-text-secondary": "var(--color-text-2)",
    "--skin-text-disabled": "var(--color-text-4)",
    "--skin-brand-primary": "var(--color-primary-6)",
    "--skin-brand-primary-hover": "var(--color-primary-5)",
    "--skin-brand-primary-active": "var(--color-primary-7)",
    "--skin-accent": "rgb(var(--link-6))",
    "--skin-danger": "rgb(var(--danger-6))",
    "--skin-success": "rgb(var(--success-6))",
    "--skin-card-border": "var(--color-border-2)",
    "--skin-card-radius": "4px",
    "--skin-game-card-radius": "8px",
    "--skin-game-card-gap": "8px",
    "--skin-header-bg": "var(--skin-bottombar-bg)",
    "--skin-header-text": "var(--color-text-1)",
    "--skin-header-text-secondary": "var(--color-text-2)",
    "--skin-header-wallet-bg": "transparent",
    "--skin-bottombar-bg": "var(--color-bg-3)",
    "--skin-bottombar-text": "var(--color-text-2)",
    "--skin-bottombar-text-active": "var(--color-text-1)",
    "--skin-bottombar-border": "rgba(255, 255, 255, 10%)",
    "--skin-bottombar-shadow": "0 -1px 0 rgba(255, 255, 255, 7%), 0 -8px 20px rgba(0, 0, 0, 26%)",
    "--skin-bottombar-deposit-bg": "linear-gradient(180deg, rgb(var(--primary-5)) 0%, rgb(var(--primary-6)) 100%)",
    "--skin-bottombar-deposit-text": "#fff",
    "--skin-bottombar-deposit-shadow": "0 6px 14px rgba(0, 0, 0, 22%), 0 0 0 1px rgba(255, 255, 255, 18%)",
    "--skin-bottombar-deposit-shadow-hover": "0 8px 18px rgba(0, 0, 0, 25%), 0 0 0 1px rgba(255, 255, 255, 20%)",
    "--skin-install-banner-overlay": "rgba(0, 0, 0, 20%)",
    "--skin-install-button-bg": "linear-gradient(to top, #ff890f, #ffee0a)",
    "--skin-install-button-text": "#a14704",
    "--skin-install-button-shadow": "0 2px 8px rgba(255, 215, 0, 40%)",
    "--skin-install-button-shadow-hover": "0 4px 12px rgba(255, 215, 0, 60%)",
    "--skin-install-slogan-bg": "linear-gradient(90deg, #ffd700 0%, #fff9c4 25%, #ffd700 50%, #fff9c4 75%, #ffd700 100%)",
    "--skin-install-close-color": "#fff",
    "--skin-user-center-mask-bg": "rgb(0 0 0 / 45%)",
    "--skin-user-center-bg": "var(--color-bg-3)",
    "--skin-user-level-bg": "#a0bfee",
    "--skin-user-level-text": "var(--color-text-1)",
    "--skin-home-hero-bg": "var(--color-bg-2)",
    "--skin-home-hero-border": "transparent",
    "--skin-home-hero-shadow": "none",
    "--skin-home-hero-radius": "12px",
    "--skin-home-carousel-dot": "var(--color-text-3)",
    "--skin-home-carousel-dot-active": "var(--color-text-1)",
    "--skin-home-widget-row-height": "76px",
    "--skin-home-widget-radius": "12px",
    "--skin-home-widget-bg": "transparent",
    "--skin-home-widget-border": "rgba(255, 209, 133, 40%)",
    "--skin-home-widget-shadow": "none",
    "--skin-home-widget-text": "var(--color-text-2)",
    "--skin-home-jackpot-bg": "radial-gradient(120% 140% at 10% 0%, rgba(255, 223, 134, 28%) 0%, rgba(118, 67, 10, 0%) 45%), linear-gradient(135deg, rgba(34, 24, 12, 95%), rgba(10, 8, 5, 90%))",
    "--skin-home-jackpot-border": "rgba(255, 209, 133, 40%)",
    "--skin-home-tab-section-shadow": "none",
    "--skin-home-tab-bg": "transparent",
    "--skin-home-tab-border": "transparent",
    "--skin-home-tab-shadow": "none",
    "--skin-home-tab-item-bg": "transparent",
    "--skin-home-tab-item-text": "var(--color-text-2)",
    "--skin-home-tab-active-bg": "rgb(var(--primary-6))",
    "--skin-home-tab-active-text": "#fff",
    "--skin-home-tab-toggle-bg": "transparent",
    "--skin-button-primary-bg": "var(--skin-brand-primary)",
    "--skin-button-primary-bg-hover": "var(--skin-brand-primary-hover)",
    "--skin-button-primary-bg-active": "var(--skin-brand-primary-active)",
    "--skin-button-primary-text": "#fff",
    "--skin-button-link-bg": "rgb(var(--link-6))",
    "--skin-button-link-bg-hover": "rgb(var(--link-5))",
    "--skin-button-secondary-bg": "var(--color-bg-9)",
    "--skin-button-secondary-bg-hover": "var(--color-bg-10)",
    "--skin-button-white-bg": "#fff",
    "--skin-button-white-bg-hover": "#e7ebf0",
    "--skin-button-white-text": "rgb(var(--primary-6))",
    "--skin-button-blue-bg": "#3c7eff",
    "--skin-button-blue-bg-hover": "rgb(var(--link-5))",
    "--skin-color-bg": "var(--color-bg-1)",
    "--skin-color-bg-elevated": "var(--color-bg-2)",
    "--skin-color-text": "var(--color-text-1)",
    "--skin-color-text-secondary": "var(--color-text-2)",
    "--skin-color-primary": "var(--color-primary-6)",
    "--skin-color-primary-hover": "var(--color-primary-5)",
    "--skin-radius-sm": "2px",
    "--skin-radius-md": "4px",
    "--skin-dialog-radius": "20px",
    "--skin-shell-width": "var(--mobile-design-shell-width, 100vw)",
  },
  pages: {},
  slots: {},
  assets: {},
};

export const blueGoldSkin: SkinDefinition = {
  id: "blueGold",
  label: "Blue Gold",
  tokens: {
    "--skin-page-bg": "#061632",
    "--skin-shell-backdrop-bg": "#020817",
    "--skin-surface-bg": "#0d2348",
    "--skin-overlay-bg": "#102a56",
    "--skin-text-primary": "#fff7d7",
    "--skin-text-secondary": "#9fb7de",
    "--skin-text-disabled": "#62789f",
    "--skin-brand-primary": "#f4c45a",
    "--skin-brand-primary-hover": "#ffd978",
    "--skin-brand-primary-active": "#d79a28",
    "--skin-accent": "#45d6ff",
    "--skin-danger": "#ff6b6b",
    "--skin-success": "#42d48b",
    "--skin-card-border": "rgba(244, 196, 90, 0.42)",
    "--skin-card-radius": "10px",
    "--skin-dialog-radius": "18px",
    "--skin-game-card-radius": "12px",
    "--skin-game-card-gap": "10px",
    "--skin-header-bg": "var(--skin-bottombar-bg)",
    "--skin-header-text": "#fff7d7",
    "--skin-header-text-secondary": "#9fb7de",
    "--skin-header-wallet-bg": "linear-gradient(180deg, #0b2552 0%, #071936 100%)",
    "--skin-bottombar-bg": "#07162e",
    "--skin-bottombar-text": "#9fb7de",
    "--skin-bottombar-text-active": "#fff7d7",
    "--skin-bottombar-border": "rgba(244, 196, 90, 0.42)",
    "--skin-bottombar-shadow": "0 -1px 0 rgba(244, 196, 90, 0.38), 0 -10px 24px rgba(0, 0, 0, 0.4)",
    "--skin-bottombar-deposit-bg": "linear-gradient(180deg, #ffe58a 0%, #d9a12f 100%)",
    "--skin-bottombar-deposit-text": "#241600",
    "--skin-bottombar-deposit-shadow": "0 8px 18px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255, 229, 138, 0.55)",
    "--skin-bottombar-deposit-shadow-hover": "0 10px 24px rgba(244, 196, 90, 0.26), 0 0 0 1px rgba(255, 229, 138, 0.72)",
    "--skin-install-banner-overlay": "linear-gradient(90deg, rgba(3, 12, 30, 0.48), rgba(16, 42, 86, 0.28))",
    "--skin-install-button-bg": "linear-gradient(180deg, #ffe58a 0%, #d9a12f 100%)",
    "--skin-install-button-text": "#241600",
    "--skin-install-button-shadow": "0 2px 10px rgba(244, 196, 90, 0.45)",
    "--skin-install-button-shadow-hover": "0 4px 14px rgba(244, 196, 90, 0.58)",
    "--skin-install-slogan-bg": "linear-gradient(90deg, #f4c45a 0%, #fff7d7 25%, #ffd978 50%, #fff0a8 75%, #f4c45a 100%)",
    "--skin-install-close-color": "#fff7d7",
    "--skin-user-center-mask-bg": "rgba(2, 8, 23, 0.68)",
    "--skin-user-center-bg": "#0d2348",
    "--skin-user-level-bg": "linear-gradient(180deg, #ffe58a 0%, #d9a12f 100%)",
    "--skin-user-level-text": "#241600",
    "--skin-home-hero-bg": "radial-gradient(circle at 18% 0%, rgba(244, 196, 90, 0.2), transparent 28%), linear-gradient(180deg, #071b43 0%, #061632 55%, #041024 100%)",
    "--skin-home-hero-border": "rgba(244, 196, 90, 0.45)",
    "--skin-home-hero-shadow": "inset 0 1px 0 rgba(255, 229, 138, 0.24), 0 8px 24px rgba(0, 0, 0, 0.22)",
    "--skin-home-hero-radius": "14px",
    "--skin-home-carousel-dot": "rgba(255, 247, 215, 0.55)",
    "--skin-home-carousel-dot-active": "#f4c45a",
    "--skin-home-widget-row-height": "82px",
    "--skin-home-widget-radius": "10px",
    "--skin-home-widget-bg": "transparent",
    "--skin-home-widget-border": "rgba(255, 218, 113, 0.72)",
    "--skin-home-widget-shadow": "0 8px 18px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 229, 138, 0.18)",
    "--skin-home-widget-text": "#d8e6ff",
    "--skin-home-jackpot-bg": "radial-gradient(circle at 50% 0%, rgba(255, 229, 138, 0.35), transparent 34%), linear-gradient(180deg, #33210b 0%, #120b05 100%)",
    "--skin-home-jackpot-border": "rgba(255, 218, 113, 0.72)",
    "--skin-home-tab-section-shadow": "none",
    "--skin-home-tab-bg": "linear-gradient(180deg, rgba(9, 34, 82, 0.98) 0%, rgba(5, 19, 45, 0.98) 100%)",
    "--skin-home-tab-border": "rgba(244, 196, 90, 0.5)",
    "--skin-home-tab-shadow": "0 8px 20px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 229, 138, 0.16)",
    "--skin-home-tab-item-bg": "transparent",
    "--skin-home-tab-item-text": "#c6d6f3",
    "--skin-home-tab-active-bg": "linear-gradient(180deg, #ffe58a 0%, #d9a12f 100%)",
    "--skin-home-tab-active-text": "#241600",
    "--skin-home-tab-toggle-bg": "rgba(255, 247, 215, 0.08)",
    "--skin-button-primary-bg": "linear-gradient(180deg, #ffe58a 0%, #d9a12f 100%)",
    "--skin-button-primary-bg-hover": "linear-gradient(180deg, #fff0a8 0%, #e4b13f 100%)",
    "--skin-button-primary-bg-active": "linear-gradient(180deg, #d99a28 0%, #b77918 100%)",
    "--skin-button-primary-text": "#241600",
    "--skin-button-link-bg": "#1d66d8",
    "--skin-button-link-bg-hover": "#2a7aff",
    "--skin-button-secondary-bg": "#18345f",
    "--skin-button-secondary-bg-hover": "#204273",
    "--skin-button-white-bg": "#fff7d7",
    "--skin-button-white-bg-hover": "#fff0a8",
    "--skin-button-white-text": "#182244",
    "--skin-button-blue-bg": "#1d66d8",
    "--skin-button-blue-bg-hover": "#2a7aff",
    "--skin-color-bg": "var(--skin-page-bg)",
    "--skin-color-bg-elevated": "var(--skin-surface-bg)",
    "--skin-color-text": "var(--skin-text-primary)",
    "--skin-color-text-secondary": "var(--skin-text-secondary)",
    "--skin-color-primary": "var(--skin-brand-primary)",
    "--skin-color-primary-hover": "var(--skin-brand-primary-hover)",
    "--skin-radius-sm": "4px",
    "--skin-radius-md": "8px",
    "--skin-shell-width": "var(--mobile-design-shell-width, 100vw)",
  },
  pages: {},
  slots: {},
  assets: {},
};

export const skinRegistry: Record<SkinId, SkinDefinition> = {
  legacy: legacySkin,
  blueGold: blueGoldSkin,
};

export const isSkinId = (skinId?: string | null): skinId is SkinId => {
  return Boolean(
    skinId && Object.prototype.hasOwnProperty.call(skinRegistry, skinId)
  );
};

export const resolveSkin = (skinId?: string): SkinDefinition => {
  if (isSkinId(skinId)) {
    return skinRegistry[skinId];
  }

  return skinRegistry[DEFAULT_SKIN_ID];
};

export const resolveSkinAsset = (
  skin: SkinDefinition,
  assetKey: string,
  fallbackSkin: SkinDefinition = legacySkin
): string | null => {
  const skinAsset = skin.assets?.[assetKey];
  if (skinAsset) {
    return skinAsset;
  }

  if (fallbackSkin.id !== skin.id) {
    return fallbackSkin.assets?.[assetKey] || null;
  }

  return null;
};

export const resolveSkinVariant = <TValue>(
  skin: SkinDefinition,
  variants: Partial<Record<SkinId, TValue>>,
  fallback?: TValue
): TValue | null => {
  return variants[skin.id] ?? variants[DEFAULT_SKIN_ID] ?? fallback ?? null;
};
